import { Component, OnInit, ViewChild } from '@angular/core';
import { GeneralService } from '../services/general.service';
import { AvtListesComponent } from '../avt-listes/avt-listes.component';
import { Router, ActivatedRoute } from '@angular/router';
import { AvtDialogDeleteComponent } from '../avt-dialog-delete/avt-dialog-delete.component';
import * as globalUrls from '../services/globalVariables';
@Component({
  selector: 'app-avt-liste-machine',
  templateUrl: './avt-liste-machine.component.html',
  styleUrls: ['./avt-liste-machine.component.scss'],
})
export class AvtListeMachineComponent implements OnInit {
  constructor(
    public generalService: GeneralService,
    public router: Router,
    public route: ActivatedRoute
  ) {}
  @ViewChild('listeComponen', { static: false })
  listeComponen: AvtListesComponent;
  datasource = [];
  listeTypeSalle = [];
  showTab: boolean = false;
  exist: boolean = false;
  column;
  type: string = '1';
  listBtn: Array<any> = [];
  listeMachine_Type = this.generalService.listeMachine_Type;
  machine_Type: string = '-1';
  title: string = '';
  // la fenetre liste machine peut etre ouvert par le composons avtActionComponont ppour rechercher une salle
  // dans se k il faus masquer les bouton modifier et ajouter
  showButtonChoisir: boolean = false;
  ngOnInit() {
    this.readParamUrl();
  }
  exportToExcel() {
    this.generalService.exportToExcel(
      this.listeComponen,
      'LISTE' + this.title.toUpperCase()
    );
  }
  getTypeSalleEtBatiment() {
    // this.generalService.rechercheTable(this.generalService.urlParametre+"&val=SALL01").subscribe(typeSalle =>
    // {
    this.generalService
      .rechercheTable(globalUrls.urlParametre + '&val=SALL02')
      .subscribe((batiment) => {
        var liste = [];
        this.datasource.forEach((d) => {
          var type1 = '';
          var type = this.generalService.typeSalle.find((t) => {
            return t.DiverSys_Index == d.Machine_Type;
          });
          if (type != undefined) type1 = type.DiverSys_Titre;
          var bati = batiment.DiverSys.find((t) => {
            return t.DiverSys_Index == d.Machine_CapTemps;
          });
          if (bati != undefined) bati = bati.DiverSys_Titre;
          liste.push({
            Machine_Code: d.Machine_Code,
            type: type1,
            numPort: d.Machine_Emp2,
            Batiment: bati,
            etage: d.Machine_Fournisseur,
            nbrPlace: d.Machine_TR,
          });
        });
        this.datasource = liste;
        this.listeComponen.setDataSource(liste);
        this.exist = true;
      });

    // });
  }
  getDataMachine() {
    this.showTab = true;
    setTimeout(() => {
      this.generalService
        .rechercheTable(
          this.generalService.url + 'avtMachineT&param=' + this.type
        )
        .subscribe((data) => {
          if (this.generalService.fenetreAvtListeMachineFilter)
            data = data.filter(
              this.generalService.fenetreAvtListeMachineFilter
            );
          this.datasource = data;
          this.generateDate();
          this.listeComponen.row = null;
          //
        });
    }, 50);
  }
  generateDate() {
    if (this.type == '2') {
      this.getTypeSalleEtBatiment();
    }
    if (this.type == '1') {
      this.getMachineMultimediaEtCarburantEtTypeSalle();
    }
  }
  getMachineMultimediaEtCarburantEtTypeSalle() {
    this.generalService
      .rechercheTable(globalUrls.urlParametre + '&val=MACH02')
      .subscribe((listeMultimedia) => {
        this.generalService
          .rechercheTable(globalUrls.urlParametre + '&val=MACH01')
          .subscribe((listeCarburent) => {
            this.generalService
              .rechercheTable(globalUrls.urlParametre + '&val=MACH03')
              .subscribe((listeIndustriels) => {
                this.generalService
                  .rechercheTable(globalUrls.urlParametre + '&val=MACH04')
                  .subscribe((listeBTP) => {
                    // this.generalService.rechercheTable(this.generalService.urlParametre+"&val=SALL01").subscribe(listeTypeSalle =>
                    // {
                    var liste = [];
                    this.datasource.forEach((d) => {
                      if (d.Machine_Type == 1) {
                        var carburent = listeCarburent.DiverSys.find((c) => {
                          return c.DiverSys_Index == d.Machine_CH;
                        });
                        if (carburent != undefined)
                          carburent = carburent.DiverSys_Titre;
                        liste.push({
                          Machine_Code: d.Machine_Code,
                          type: d.Machine_CapUnite,
                          numSerie: d.Machine_Serie,
                          detaile: carburent,
                          Machine_Type: d.Machine_Type,
                        });
                      }
                      if (d.Machine_Type == 2) {
                        var multimedia = listeMultimedia.DiverSys.find((c) => {
                          return c.DiverSys_Index == d.Machine_CH;
                        });
                        if (multimedia != undefined)
                          multimedia = multimedia.DiverSys_Titre;
                        var type1 = '';
                        var type = this.generalService.typeSalle.find((c) => {
                          return c.DiverSys_Index == d.Machine_Compteur;
                        });
                        if (type != undefined) type1 = type.DiverSys_Titre;
                        liste.push({
                          Machine_Code: d.Machine_Code,
                          type: multimedia,
                          numSerie: d.Machine_Serie,
                          detaile: type1,
                          Machine_Type: d.Machine_Type,
                        });
                      }
                      if (d.Machine_Type == 3) {
                        var industriels = listeIndustriels.DiverSys.find(
                          (c) => {
                            return c.DiverSys_Index == d.Machine_CH;
                          }
                        );
                        if (industriels != undefined)
                          industriels = industriels.DiverSys_Titre;
                        var type = this.generalService.typeSalle.find((c) => {
                          return c.DiverSys_Index == d.Machine_Compteur;
                        });
                        var type1 = '';
                        if (type != undefined) type1 = type.DiverSys_Titre;
                        liste.push({
                          Machine_Code: d.Machine_Code,
                          type: industriels,
                          numSerie: d.Machine_Serie,
                          detaile: type1,
                          Machine_Type: d.Machine_Type,
                        });
                      }
                      if (d.Machine_Type == 4) {
                        var btp = listeBTP.DiverSys.find((c) => {
                          return c.DiverSys_Index == d.Machine_CH;
                        });
                        if (btp != undefined) btp = btp.DiverSys_Titre;
                        var type = this.generalService.typeSalle.find((c) => {
                          return c.DiverSys_Index == d.Machine_Compteur;
                        });
                        var type1 = '';
                        if (type != undefined) type1 = type.DiverSys_Titre;
                        liste.push({
                          Machine_Code: d.Machine_Code,
                          type: btp,
                          numSerie: d.Machine_Serie,
                          detaile: type1,
                          Machine_Type: d.Machine_Type,
                        });
                      }
                    });
                    this.datasource = liste;
                    this.listeComponen.setDataSource(liste);
                    this.exist = true;
                    // });
                  });
              });
          });
      });
  }
  filterMachine() {
    if (this.machine_Type != '-1')
      this.listeComponen.setDataSource(
        this.datasource.filter((machine) => {
          return machine.Machine_Type == this.machine_Type;
        })
      );
    else this.listeComponen.setDataSource(this.datasource);
  }
  getColumnMachine() {
    //salle
    if (this.type == '2')
      // si vous modifier les champs TableRD_Champs (type,numPort, Batiment...) modifier les dans avtAction
      this.column = {
        TableRD: [
          {
            TableRE_Code: '',
            TableRD_Champs: 'Machine_Code',
            Lg_Code: '',
            TableRD_Des: 'Code',
            TableRD_Largeur: 50,
            TableRD_ReadOnly: true,
            TableRD_Format: '',
            TableRD_Alligement: 0,
            TableRD_Ordre: 0,
            TableRD_Type: 0,
            TableRD_Param1: null,
            TableRD_Param2: null,
            TableRD_ValDef: null,
            TableRD_Tri: true,
            TableRD_Valid: null,
            TableRD_ValidType: 0,
            TableRD_ExpressionH: null,
            TableRD_ExpressionR: null,
            User_Id: '*',
            User_Groupe: null,
          },
          {
            TableRE_Code: '',
            TableRD_Champs: 'type',
            Lg_Code: '',
            TableRD_Des: 'Type',
            TableRD_Largeur: 150,
            TableRD_ReadOnly: true,
            TableRD_Format: '',
            TableRD_Alligement: 0,
            TableRD_Ordre: 0,
            TableRD_Type: 0,
            TableRD_Param1: null,
            TableRD_Param2: null,
            TableRD_ValDef: null,
            TableRD_Tri: true,
            TableRD_Valid: null,
            TableRD_ValidType: 0,
            TableRD_ExpressionH: null,
            TableRD_ExpressionR: null,
            User_Id: '*',
            User_Groupe: null,
          },
          {
            TableRE_Code: '',
            TableRD_Champs: 'numPort',
            Lg_Code: '',
            TableRD_Des: 'N° Porte',
            TableRD_Largeur: 70,
            TableRD_ReadOnly: true,
            TableRD_Format: '',
            TableRD_Alligement: 0,
            TableRD_Ordre: 0,
            TableRD_Type: 0,
            TableRD_Param1: null,
            TableRD_Param2: null,
            TableRD_ValDef: null,
            TableRD_Tri: true,
            TableRD_Valid: null,
            TableRD_ValidType: 0,
            TableRD_ExpressionH: null,
            TableRD_ExpressionR: null,
            User_Id: '*',
            User_Groupe: null,
          },
          {
            TableRE_Code: '',
            TableRD_Champs: 'Batiment',
            Lg_Code: '',
            TableRD_Des: 'Bâtiment',
            TableRD_Largeur: 200,
            TableRD_ReadOnly: true,
            TableRD_Format: '',
            TableRD_Alligement: 0,
            TableRD_Ordre: 0,
            TableRD_Type: 0,
            TableRD_Param1: null,
            TableRD_Param2: null,
            TableRD_ValDef: null,
            TableRD_Tri: true,
            TableRD_Valid: null,
            TableRD_ValidType: 0,
            TableRD_ExpressionH: null,
            TableRD_ExpressionR: null,
            User_Id: '*',
            User_Groupe: null,
          },
          {
            TableRE_Code: '',
            TableRD_Champs: 'etage',
            Lg_Code: '',
            TableRD_Des: 'Etage',
            TableRD_Largeur: 50,
            TableRD_ReadOnly: true,
            TableRD_Format: '',
            TableRD_Alligement: 0,
            TableRD_Ordre: 0,
            TableRD_Type: 0,
            TableRD_Param1: null,
            TableRD_Param2: null,
            TableRD_ValDef: null,
            TableRD_Tri: true,
            TableRD_Valid: null,
            TableRD_ValidType: 0,
            TableRD_ExpressionH: null,
            TableRD_ExpressionR: null,
            User_Id: '*',
            User_Groupe: null,
          },
          {
            TableRE_Code: '',
            TableRD_Champs: 'nbrPlace',
            Lg_Code: '',
            TableRD_Des: 'Nbr Place',
            TableRD_Largeur: 80,
            TableRD_ReadOnly: true,
            TableRD_Format: '',
            TableRD_Alligement: 0,
            TableRD_Ordre: 0,
            TableRD_Type: 0,
            TableRD_Param1: null,
            TableRD_Param2: null,
            TableRD_ValDef: null,
            TableRD_Tri: true,
            TableRD_Valid: null,
            TableRD_ValidType: 0,
            TableRD_ExpressionH: null,
            TableRD_ExpressionR: null,
            User_Id: '*',
            User_Groupe: null,
          },
        ],
      };
    //machine
    if (this.type == '1')
      this.column = {
        TableRD: [
          {
            TableRE_Code: '',
            TableRD_Champs: 'Machine_Code',
            Lg_Code: '',
            TableRD_Des: 'Code',
            TableRD_Largeur: 50,
            TableRD_ReadOnly: true,
            TableRD_Format: '',
            TableRD_Alligement: 0,
            TableRD_Ordre: 0,
            TableRD_Type: 0,
            TableRD_Param1: null,
            TableRD_Param2: null,
            TableRD_ValDef: null,
            TableRD_Tri: true,
            TableRD_Valid: null,
            TableRD_ValidType: 0,
            TableRD_ExpressionH: null,
            TableRD_ExpressionR: null,
            User_Id: '*',
            User_Groupe: null,
          },
          {
            TableRE_Code: '',
            TableRD_Champs: 'type',
            Lg_Code: '',
            TableRD_Des: 'Type',
            TableRD_Largeur: 150,
            TableRD_ReadOnly: true,
            TableRD_Format: '',
            TableRD_Alligement: 0,
            TableRD_Ordre: 0,
            TableRD_Type: 0,
            TableRD_Param1: null,
            TableRD_Param2: null,
            TableRD_ValDef: null,
            TableRD_Tri: true,
            TableRD_Valid: null,
            TableRD_ValidType: 0,
            TableRD_ExpressionH: null,
            TableRD_ExpressionR: null,
            User_Id: '*',
            User_Groupe: null,
          },
          {
            TableRE_Code: '',
            TableRD_Champs: 'numSerie',
            Lg_Code: '',
            TableRD_Des: 'Série',
            TableRD_Largeur: 150,
            TableRD_ReadOnly: true,
            TableRD_Format: '',
            TableRD_Alligement: 0,
            TableRD_Ordre: 0,
            TableRD_Type: 0,
            TableRD_Param1: null,
            TableRD_Param2: null,
            TableRD_ValDef: null,
            TableRD_Tri: true,
            TableRD_Valid: null,
            TableRD_ValidType: 0,
            TableRD_ExpressionH: null,
            TableRD_ExpressionR: null,
            User_Id: '*',
            User_Groupe: null,
          },
          {
            TableRE_Code: '',
            TableRD_Champs: 'detaile',
            Lg_Code: '',
            TableRD_Des: 'Détaile',
            TableRD_Largeur: 150,
            TableRD_ReadOnly: true,
            TableRD_Format: '',
            TableRD_Alligement: 0,
            TableRD_Ordre: 0,
            TableRD_Type: 0,
            TableRD_Param1: null,
            TableRD_Param2: null,
            TableRD_ValDef: null,
            TableRD_Tri: true,
            TableRD_Valid: null,
            TableRD_ValidType: 0,
            TableRD_ExpressionH: null,
            TableRD_ExpressionR: null,
            User_Id: '*',
            User_Groupe: null,
          },
        ],
      };

    this.getDataMachine();
  }
  clickBtnHeat(event) {
    switch (event.name) {
      case 'consulter': {
        this.goToMachine('3');
        break;
      }
      case 'modifier': {
        this.goToMachine('2');
        break;
      }
      case 'supprimer': {
        this.supprimer();
        break;
      }
      case 'choisir': {
        this.choisir();
        break;
      }
      case 'close': {
        this.generalService.dialogOpend.close();
        break;
      }
    }
  }
  close() {
    this.generalService.dialogOpend.close();
  }
  choisir() {
    if (this.listeComponen.row) {
      this.generalService.machineChoisie = this.listeComponen.row;
      this.generalService.dialogOpend.close();
    } else
      this.generalService.dialogSuccess(
        'Veuillez sélectionner une seule ligne',
        false
      );
  }
  // consulter()
  // {
  //   if(this.type == "1")
  //       this.router.navigate(['avt/machine/',"-1","1"]);
  //     if(this.type == "2")
  //       this.router.navigate(['avt/salle/',"-1","1"]);
  // }
  supprimer() {
    if (this.listeComponen.row) {
      const dialogConfig = this.generalService.dialogConfig;
      dialogConfig.autoFocus = true;
      var dialogRef = this.generalService.dialog.open(
        AvtDialogDeleteComponent,
        dialogConfig
      );
      dialogRef.afterClosed().subscribe((result) => {
        if (result == 'supprimer') {
          this.exist = false;
          this.listBtn[2].disabled = true;
          var compt = 1; //this.listeComponen.rows.length;
          [this.listeComponen.row].forEach((row) => {
            var deleteFn = this.generalService.supprimerSanMsgConfirm(
              row.Machine_Code,
              'machine'
            );
            if (deleteFn != null) {
              deleteFn.subscribe(
                (data) => {
                  this.generalService.dialogSuccess('Elément supprimer', true);
                  compt--;
                  if (compt == 0) {
                    this.getDataMachine();
                    this.exist = true;
                    this.listBtn[2].disabled = false;
                  }
                },
                (error) => {
                  this.generalService.dialogSuccess(
                    'Elément non supprimé',
                    false
                  );
                  this.exist = true;
                  this.listBtn[2].disabled = false;
                }
              );
            }
          });
        }
        if (result == 'annuler') {
        }
      });
    } else
      this.generalService.dialogSuccess(
        'Veuillez sélectionner une seule ligne',
        false
      );
  }
  goToMachine(mode) {
    if (this.listeComponen.row) {
      if (this.type == '1')
        this.generalService.popupCenter(
          '/w/avt/machine/' + this.listeComponen.row.Machine_Code + '/' + mode
        );
      if (this.type == '2')
        this.generalService.popupCenter(
          '/w/avt/salle/' + this.listeComponen.row.Machine_Code + '/' + mode
        );
    } else
      this.generalService.dialogSuccess(
        'Veuillez sélectionner une seule ligne',
        false
      );
  }
  generateBtn() {
    if (this.showButtonChoisir)
      this.listBtn = [
        {
          name: 'choisir',
          class: 'colorBlue',
          text: 'Choisir',
          disabled: false,
          icon: 'mouse',
        },
        {
          name: 'close',
          class: 'colorRed',
          text: 'Fermer',
          disabled: false,
          icon: 'close',
        },
      ];
    else
      this.listBtn = [
        {
          name: 'consulter',
          class: 'colorGray',
          text: 'Consulter',
          disabled: false,
          icon: 'import_contacts',
        },
        {
          name: 'modifier',
          class: 'colorBlue',
          text: 'Modifier',
          disabled: false,
          icon: 'edite',
        },
        {
          name: 'supprimer',
          class: 'colorRed',
          text: 'Supprimer',
          disabled: false,
          icon: 'delete',
        },
      ];
  }
  readParamUrl() {
    this.route.params.subscribe((params) => {
      this.showTab = false;
      this.type = params['type'];
      if (!this.generalService.isNotEmpty(this.type)) {
        this.showButtonChoisir = true;
        this.type = this.generalService.fenetreAvtListeMachine;
      }

      this.generateBtn();
      if (this.type == '1') this.title = 'Véhicules & Équipements';
      if (this.type == '2') this.title = 'Salles / Ateliers';
      setTimeout(() => {
        this.getColumnMachine();
      }, 50);
    });
  }
}
